<ng-container *ngIf="checkPoint">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            Realizar punto de control: {{checkPoint.checkPoint}}
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="formCheckPoint">
            <div class="form-group">
                <label for="comments">Comentarios</label>
                <textarea id="comments" formControlName="comments" class="form-control" rows="5"
                    placeholder="Comentarios"></textarea>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <div class="btn-group w-100" role="group">
            <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close()" [disabled]="isSaving">
                <span>Cancelar</span>
            </button>
            <button type="button" class="btn btn-success" [disabled]="isSaving" (click)="save()">
                <span>Guardar</span>
                <div class="spinner-border" role="status" *ngIf="isSaving">
                    <span class="visually-hidden"></span>
                </div>
            </button>
        </div>
    </div>
</ng-container>